export default "__VITE_ASSET__D9GSm9UL__"